import { Text } from '@gympass/yoga';
import { AlertTriangle } from '@gympass/yoga-icons';
import { useIntl } from 'react-intl';
import { getFullNameInitials } from 'utils/helpers';

import { useCareMatrix } from 'hooks/useCareMatrix';

import { ChatConversationHeaderProps } from './types';

import * as S from './styles';

const ChatConversationHeader: React.FC<ChatConversationHeaderProps> = ({
  fullName,
  avatarColor,
  userCognitoId,
  willBeUnlinked = false,
  closeConversation,
  ...props
}) => {
  const intl = useIntl();
  const { openModule } = useCareMatrix();

  function handleOpenCareMatrixModule() {
    openModule(userCognitoId);
  }

  return (
    <>
      <S.ChatConversationHeaderRoot {...props}>
        <S.BackButton onClick={closeConversation}>
          <S.BackArrow />
        </S.BackButton>

        <S.ChatConversationHeaderAvatar $bgColor={avatarColor}>
          <Text color="white">{getFullNameInitials(fullName)}</Text>
        </S.ChatConversationHeaderAvatar>
        <S.ChatConversationHeaderName
          title={`${intl.formatMessage({
            id: 'CHAT.PAGE.CONVERSATION.HEADER.TITLE',
          })}`}
          onClick={handleOpenCareMatrixModule}
        >
          {fullName}
        </S.ChatConversationHeaderName>
      </S.ChatConversationHeaderRoot>

      {willBeUnlinked && (
        <S.WarningBanner
          variant="attention"
          message={intl.formatMessage({
            id: 'ELIGIBILITYSHUTDOWNCPTC.WARNINGBANNER.PSYCHOLOGICALRECORD',
          })}
          icon={AlertTriangle}
        />
      )}
    </>
  );
};

export default ChatConversationHeader;
